import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'lib-sort-icon',
  standalone: true,
  template: `
    <svg
      [class]="iconClass()"
      [attr.width]="width()"
      [attr.height]="height()"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.50853 17.0832L3.3252 12.9082"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M7.5083 2.91699V17.0837"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M12.4917 2.91699L16.675 7.09199"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M12.4917 17.0837V2.91699"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
  `,
})
export class SortIconComponent extends BaseIconComponent {
  override viewBox = input<string>('0 0 20 20');
}
